<!--&================= TITLE =================&-->
<div class="title-components">
  <h1>Versión Por Revisión</h1>
</div>

<div class="divider-butons-VH">
  <div (click)="ToggleModalHelp(true)" class="btn btn-icon-text-left">
    <span class="text">Ayuda</span><i class="fa-regular fa-circle-question"></i>
  </div>
</div>

<div class="Container-Card-General">

  <ng-container *ngFor="let Annexe of List_History_Annexe;let i = index">



    <div *ngIf="i%2===0" class="Card-Left">

      <div class="Left">

        <div class="Square A{{Annexe.Status}}">

          <div class="Text">
            <h1>Anexo</h1>
            <div class="Subtitle">{{Annexe.Name}}</div>
          </div>

          <div class="C-Circle A{{Annexe.Status}}">

            <div class="Circle A{{Annexe.Status}}">
              <i class="fa-regular fa-file-lines"></i>
            </div>

          </div>
        </div>
      </div>

      <div class="Middle">
        <div class="Square A{{Annexe.Status}}">
          <div class="Circle">
          </div>
        </div>
      </div>

      <div class="Right">
        <div class="Container-R">
          <div class="Title A{{Annexe.Status}}">
            Información
          </div>
          <div class="Information">
            <div class="Grid-2">
              <div class="Text">Contribuidor: </div>
              <div class="Description">{{Annexe.Contributor_Name}}</div>
            </div>

            <div class="Grid-2">
              <div class="Text">Anexo documento: </div>
              <div class="Description">{{Annexe.FIN_Name}}</div>
            </div>

            <div class="Grid-2">
              <div class="Text">Fecha de carga: </div>
              <div class="Description">{{Date_Format(Annexe.Upload_Date)}}</div>
            </div>

          </div>
        </div>
      </div>

    </div>

    <div *ngIf="i%2!==0" class="Card-Right">

      <div class="Right">
        <div class="Container-R">
          <div class="Title A{{Annexe.Status}}">
            Información
          </div>
          <div class="Information">

            <div class="Grid-2">
              <div class="Text">Contribuidor: </div>
              <div class="Description">{{Annexe.Contributor_Name}}</div>
            </div>

            <div class="Grid-2">
              <div class="Text">Anexo documento: </div>
              <div class="Description">{{Annexe.FIN_Name}}</div>
            </div>

            <div class="Grid-2">
              <div class="Text">Fecha de carga: </div>
              <div class="Description">{{Date_Format(Annexe.Upload_Date)}}</div>
            </div>

          </div>
        </div>
      </div>

      <div class="Middle">
        <div class="Square A{{Annexe.Status}}">
          <div class="Circle">
          </div>
        </div>
      </div>

      <div class="Left">

        <div class="Square A{{Annexe.Status}}">

          <div class="Text">
            <h1>Anexo</h1>
            <div class="Subtitle">{{Annexe.Name}}</div>
          </div>

          <div class="C-Circle A{{Annexe.Status}}">

            <div class="Circle A{{Annexe.Status}}">
              <i class="fa-regular fa-file-lines"></i>
            </div>

          </div>
        </div>
      </div>

    </div>


  </ng-container>




</div>



<!---===================== MODAL FOR HELP ICONS =====================--->
<section class="Modal-Global" id="ModalIconsHelp">
  <div class="wrapper">
    <div class="Local-M-Icon-Popup popup">
      <div class="Local-M-Icon-inside popup-inside">
        <div class="Local-M-Icon-backgrounds backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>
      <div class="Local-M-Icon-content content">
        <div (click)=" ToggleModalHelp(false)" class="Btn-Close"><i class="fa-solid fa-xmark"></i></div>
        <div class="Content-Top">
          <h2>Iconografía</h2>
        </div>

        <div class="Content-body">
          <div class="Info-Icons">
            <div class="Header grid-column-2">
              <div class="Icon-container">
                Icono
              </div>
              <div class="Description">
                Descripción
              </div>
            </div>
            <div *ngFor="let icon of Icons;let i = index" class="grid-column-2">
              <div class="Icon-container">
                <div class="Icon-Status StatusA{{icon.Status}}">
                  <div><i class="fa-solid {{Icons[i].Icon}}"></i></div>
                </div>
              </div>
              <div class="Description">
                {{icon.Description}}
              </div>
            </div>

          </div>
        </div>
        <div class="Local-M-Icon-Bottom Content-Bottom">
          <div (click)=" ToggleModalHelp(false)" class="Btn-Close-Modal">
            <span>Cerrar</span>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>


<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
